import { toLatinDigits } from './digits.js';

function isGregorianLeapYear(y: number): boolean {
  return (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0;
}

export function gregorianMonthLength(y: number, m: number): number {
  const lengths = [31, isGregorianLeapYear(y) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  return lengths[m - 1] as number;
}

/**
 * Parses an expiry date typed in GREGORIAN (as printed on boxes) into `YYYY-MM-DD` (BR-04).
 * Accepts Persian digits and any separators. `2027-02` (month and year only) means the last
 * day of that month. Boxes that print the month first (`05/2027`) are read the same way; a day
 * with a month-first form is not accepted, since 03/04/2027 is ambiguous. Returns null for anything
 * that is not a valid date in 1900..2200.
 */
export function parseExpiryInput(value: string): string | null {
  const tokens = toLatinDigits(value).match(/\d+/g);
  if (!tokens || tokens.length < 2) return null;
  const first = tokens[0];
  const second = tokens[1] as string;
  if (tokens.length === 2 && first.length <= 2 && second.length === 4) {
    const month = Number.parseInt(first, 10);
    const year = Number.parseInt(second, 10);
    if (!(year >= 1900 && year <= 2200) || !(month >= 1 && month <= 12)) return null;
    return `${year}-${String(month).padStart(2, '0')}-${String(gregorianMonthLength(year, month)).padStart(2, '0')}`;
  }
  const y = Number.parseInt(tokens[0], 10);
  const m = Number.parseInt(tokens[1] as string, 10);
  if (!(y >= 1900 && y <= 2200) || !(m >= 1 && m <= 12)) return null;
  const last = gregorianMonthLength(y, m);
  const d = tokens.length >= 3 ? Number.parseInt(tokens[2] as string, 10) : last;
  if (!(d >= 1 && d <= last)) return null;
  return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
}
